import React, { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import EraserSolid from "../../../../assets/icons/eraser-solid.svg";
import Chip from "../../../../components/basics/Chip";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Card from "../../../../components/cards/Card";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Prescricao";

const AccordionPrescricaoCadastroOlhos = ({ ...props }) => {
  const { handleChangeOpenAcordion } = usePrescricaoController();
  const { expanded } = useContext(PrescricaoContext);

  // falta regras de valores permitidos em cada campo
  // e lógica para limpar medidas de cada olho

  return (
    <>
      <Grid item xs={12}>
        <Accordion expanded={expanded.eyes || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("eyes")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs onClick={() => handleChangeOpenAcordion("eyes")}>
                  <Chip label="OLHOS" bgcolor={"default"} />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Card>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs>
                                <Chip label="ESQUERDO" bgcolor="secondary" />
                              </Grid>
                              <Grid item flex={1}>
                                <Tooltip title="Limpar medidas Olho Esquerdo">
                                  <IconButtonStyled
                                    size="small"
                                    onClick={() => {}}
                                  >
                                    <img src={EraserSolid} alt="limpar" />
                                  </IconButtonStyled>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Esférico"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Cilíndrico"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Eixo"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Adição"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Altura"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="DNP"
                            ></TextFieldErp>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item xs={6}>
                      <Card>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs>
                                <Chip label="DIREITO" bgcolor="secondary" />
                              </Grid>
                              <Grid item flex={1}>
                                <Tooltip title="Limpar medidas Olho Direito">
                                  <IconButtonStyled
                                    size="small"
                                    onClick={() => {}}
                                  >
                                    <img src={EraserSolid} alt="limpar" />
                                  </IconButtonStyled>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Esférico"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Cilíndrico"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Eixo"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Adição"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="Altura"
                            ></TextFieldErp>
                          </Grid>
                          <Grid item xs={6}>
                            <TextFieldErp
                              type="number"
                              label="DNP"
                            ></TextFieldErp>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default AccordionPrescricaoCadastroOlhos;
